/**
 * Card rails: horizontal snap lists marked ul[data-card-rail] (design examples, reveal videos).
 * On desktop, adds round previous/next arrows at the row's edges that page through the cards and
 * hide at either end or when everything fits. The scrollbar is hidden in the markup; mobile swipes.
 * Arrow styles: .gallery-nav / .gallery-nav--rail in config/styles.css.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const arrow = (dir) => {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = `gallery-nav gallery-nav--rail gallery-nav--${dir}`;
  b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
  b.innerHTML = `<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${dir === 'prev' ? 'M12.5 4.5 7 10l5.5 5.5' : 'M7.5 4.5 13 10l-5.5 5.5'}"/></svg>`;
  return b;
};

function setup(rail) {
  if (rail.dataset.railReady) return;
  rail.dataset.railReady = 'true';
  const wrap = document.createElement('div');
  wrap.className = 'card-rail-wrap';
  rail.before(wrap);
  wrap.append(rail);
  const prev = arrow('prev');
  const next = arrow('next');
  wrap.append(prev, next);

  const update = () => {
    const max = rail.scrollWidth - rail.clientWidth;
    const pos = Math.abs(rail.scrollLeft);
    prev.hidden = max <= 4 || pos <= 4;
    next.hidden = max <= 4 || pos >= max - 4;
  };
  const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
  const page = (d) => {
    const card = rail.firstElementChild;
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = card ? card.offsetWidth + gap : rail.clientWidth;
    const perPage = Math.max(1, Math.floor((rail.clientWidth + gap) / step) - 0);
    rail.scrollBy({ left: d * rtl * step * perPage, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  };
  prev.addEventListener('click', () => page(-1));
  next.addEventListener('click', () => page(1));
  rail.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  new ResizeObserver(update).observe(rail);
  update();
}

const init = () => document.querySelectorAll('ul[data-card-rail]').forEach(setup);
init();
document.addEventListener('DOMContentLoaded', init);
